const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
});

function formatGbp(amount) {
  const n = Number(amount);
  if (Number.isNaN(n)) return null;
  return gbpFormatter.format(n);
}

/** Refund amount when payment was taken; null when unpaid / invoice-only adjustment. */
export function getReplacementUpdateRefundAmount(data) {
  const raw = data?.refundableAmount ?? data?.refundedAmount ?? null;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (Number.isNaN(n) || n <= 0) return null;
  return n;
}

function formatDateLabel(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/**
 * Toast copy when smart matching / replacement could not find a worker.
 * @param {object} data - `replacement-update` socket payload
 * @returns {{ message: string, toastType: "success" | "info" }}
 */
export function buildReplacementUpdateToast(data) {
  const bookingRef = data?.bookingSlug
    ? `booking ${data.bookingSlug}`
    : "your booking";
  const shiftNum =
    data?.shiftIndex != null && !Number.isNaN(Number(data.shiftIndex))
      ? Number(data.shiftIndex) + 1
      : null;
  const shiftPart = shiftNum != null ? ` for shift ${shiftNum}` : "";

  const dateLabels = (Array.isArray(data?.dates) ? data.dates : [])
    .map((entry) =>
      typeof entry === "string" ? entry : entry?.date ?? null
    )
    .map(formatDateLabel)
    .filter(Boolean);

  let message = `No replacement worker could be found${shiftPart} on ${bookingRef}.`;
  if (dateLabels.length) {
    const unique = [...new Set(dateLabels)];
    message += ` Affected date${unique.length > 1 ? "s" : ""}: ${unique.join(", ")}.`;
  }

  const refundAmount = getReplacementUpdateRefundAmount(data);
  if (refundAmount != null) {
    const formattedRefund = formatGbp(refundAmount);
    message += ` ${formattedRefund} has been refunded to you.`;
    const credit = Number(data?.totalCredit);
    if (data?.totalCredit != null && !Number.isNaN(credit)) {
      message += ` Your credit balance is now ${formatGbp(credit)}.`;
    }
    return { message, toastType: "success" };
  }

  message +=
    " No payment was taken for this booking; your invoice has been adjusted accordingly.";
  return { message, toastType: "info" };
}
